<div class="container-fluid ">
    <h2 class="rounded mt-3 text-center">Individual Session</h2>
<!--    <prettyjson [obj]="form.value"></prettyjson>-->
    <form [formGroup]="form">
        <div class="row">
<!--            <mat-form-field appearance='outline' class="col-md-6 col-sm-12">-->
<!--              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Centre Name']">info</mat-icon>-->
<!--                <mat-label>AL Centre Name</mat-label>-->
<!--                <mat-select (selectionChange)="fetchChildren($event)" required [formControl]="centreSelect">-->
<!--                    <mat-option *ngFor="let  c of (centres$|async)" [value]="c">{{c.centreName}}</mat-option>-->
<!--                </mat-select>-->
<!--                <mat-error *ngIf="centreSelect?.errors?.required">Required</mat-error>-->
<!--            </mat-form-field>-->

          <app-searchable-select class="col-md-6"
                                 [options]="centres$ | async"
                                 [selectedValue]="selectedCentre"
                                 [displayWithFn]="displayCentre"
                                 [placeholder]="'Select Centre'"
                                 [label]="'Select Centre'"
                                 (selectionChange)="onCentreSelect($event)"
          ></app-searchable-select>


<!--          <mat-form-field appearance='outline' class="col-md-6 col-sm-12">-->
<!--              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Child Name']">info</mat-icon>-->
<!--                <mat-label>-->
<!--                    Child Name-->
<!--                </mat-label>-->
<!--                <mat-select (selectionChange)="onChildSelect($event)" [formControl]="childSelect">-->
<!--                    <mat-option *ngFor="let  c of (childrenData)" [value]="c" [ngClass]="{'yellow' : (c.admissionData.length>2 )}"  >{{c.firstName}} {{c.lastName}}</mat-option>-->
<!--                </mat-select>-->
<!--                <mat-error *ngIf="childSelect?.errors?.required">Required</mat-error>-->
<!--            </mat-form-field>-->


          <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
            <mat-icon
              *ngIf="mGlossaryData"
              matSuffix
              matTooltipPosition="above"
              [matTooltip]="mGlossaryData['Child Name']">
              info
            </mat-icon>

            <mat-label>Child Name</mat-label>

            <mat-select
              [formControl]="childSelect"
              (selectionChange)="onChildSelect($event)"
              (opened)="onChildDropdownOpen()">

              <!-- 🔍 SEARCH BOX -->
              <mat-option class="no-select-option" (click)="$event.stopPropagation()">
                <div class="mat-select-search">
                  <input
                    matInput
                    placeholder="Search child..."
                    [formControl]="childSearchControl"
                    autocomplete="off"
                    (keydown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                    (focus)="$event.stopPropagation()"
                  />
                </div>
              </mat-option>

              <!-- FILTERED CHILD LIST -->
              <mat-option
                *ngFor="let c of filteredChildData"
                [value]="c"
                [ngClass]="{ 'yellow': (c?.admissionData?.length ?? 0) > 2 }">
                {{ c.firstName }} {{ c.lastName }}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="childSelect?.errors?.required">
              Required
            </mat-error>
          </mat-form-field>



          <!*--------------------------------------------- DATE --------------------------------------------->
            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="date" [max]="maxDate">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="form.controls.date?.errors?.required">Required</mat-error>

            </mat-form-field>

            <!*--------------------------------------------- Session Type--------------------------------------------->
            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Session Type']">info</mat-icon>

                <mat-label>Session Type</mat-label>
                <mat-select required formControlName="type">
                    <mat-option *ngFor="let t of types" [value]="t">{{t}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="col-md-6 col-sm-12" appearance="outline">
                <mat-label>Time In</mat-label>
                <!-- The timepicker input -->
                <input matTimepicker #t="matTimepicker" formControlName="startTime" [value]="startTime"
                       [strict]="false" id="start-time-select" mode="12h"
                       placeholder="Please select time..." name="time">
                <!-- An icon for the timepicker input that will open the timepicker dialog when clicked -->
                <mat-icon matSuffix (click)="t.showDialog()">access_time</mat-icon>
                <!-- Error that will be shown when the input date is invalid -->
                <!--            <mat-error *ngIf="eventTime?.touched && eventTime?.invalid">Invalid Date</mat-error>-->
                <mat-error *ngIf="form.controls.startTime?.errors?.required">Required</mat-error>
            </mat-form-field>

            <mat-form-field class="col-md-6 col-sm-12" appearance="outline">
                <mat-label>Time Out</mat-label>
                <!-- The timepicker input -->
                <input matTimepicker #t1="matTimepicker" formControlName="endTime" [value]="endTime"
                       [strict]="false" id="end-time-select" mode="12h"
                       placeholder="Please select time..." name="time">
                <!-- An icon for the timepicker input that will open the timepicker dialog when clicked -->
                <mat-icon matSuffix (click)="t1.showDialog()">access_time</mat-icon>
                <!-- Error that will be shown when the input date is invalid -->
                <!--            <mat-error *ngIf="eventTime?.touched && eventTime?.invalid">Invalid Date</mat-error>-->
                <mat-error *ngIf="form.controls.endTime?.errors?.required">Required</mat-error>

            </mat-form-field>
            <!*--------------------------------------------- Participants--------------------------------------------->
            <mat-form-field appearance='outline' class="col-md-6 col-sm-12">
              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Participants']">info</mat-icon>

                <mat-label>
                    Participants
                </mat-label>

                <mat-select multiple formControlName="participants" >
                  <mat-option value="Father (Males)">Father (Males)</mat-option>
                  <mat-option value="Mother (Females)">Mother (Females)</mat-option>
                  <mat-option value="Brother">Brother</mat-option>
                  <mat-option value="Sister">Sister</mat-option>
                  <mat-option value="Grandfather">Grandfather</mat-option>
                  <mat-option value="Grandmother">Grandmother</mat-option>
                  <mat-option value="Uncle">Uncle</mat-option>
                  <mat-option value="Aunt">Aunt</mat-option>
                  <mat-option value="Teen">Teen</mat-option>
                  <mat-option value="Child">Child</mat-option>

                </mat-select>
                <mat-error *ngIf="form.controls.sessionFor?.errors?.required">Required</mat-error>

            </mat-form-field>
            <!*--------------------------------------------- Session Mode--------------------------------------------->
            <mat-form-field appearance='outline' class="col-md-6 col-sm-12">
              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Mode Of Session']">info</mat-icon>

                <mat-label>
                    Mode Of Session
                </mat-label>

                <mat-select formControlName="sessionMode">
                    <mat-option value="In Person">In Person</mat-option>
                    <mat-option value="Online">Online</mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls.sessionMode?.errors?.required">Required</mat-error>

            </mat-form-field>
            <!*--------------------------------------------- INTERVENTION EFFECTIVENESS--------------------------------------------->
            <label class="example-radio-group-label">Intervention Effectiveness (Previous Session)</label>
            <mat-radio-group aria-label="Intervention Used" formControlName="interventionUseful" class="mb-1">
                <mat-radio-button value="Yes">Yes</mat-radio-button>&nbsp;&nbsp;
                <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>

            <!*--------------------------------------------- Intervention Effectiveness Remarks--------------------------------------------->
            <mat-form-field appearance="outline">
              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Intervention Effectiveness Remarks']">info</mat-icon>

                <mat-label>Remarks</mat-label>
                <textarea matInput  formControlName="interventionRemarks"></textarea>
                <mat-error *ngIf="form.controls.interventionRemarks?.errors?.required">Required</mat-error>
            </mat-form-field>

            <!*--------------------------------------------- Home Program Effectiveness (Previous Session) --------------------------------------------->
            <label class="example-radio-group-label">Home Program Effectiveness (Previous Session)</label>
            <mat-radio-group aria-label="Home Program" formControlName="homeProgramEffectiveness" class="mb-1">
                <mat-radio-button value="Yes">Yes</mat-radio-button>&nbsp;&nbsp;
                <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>

            <mat-form-field appearance="outline">
              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Home Program Effectiveness Remarks']">info</mat-icon>
                <mat-label>Remark</mat-label>
                <textarea matInput formControlName="remark" (blur)="onBlur(form.controls.remark)"></textarea>
                <!--                <mat-error *ngIf="form.controls.remark?.errors?.required">Required</mat-error>-->
            </mat-form-field>

            <!*--------------------------------------------- CHALLENGES FACED--------------------------------------------->
            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
                <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Challenges Faced']">info</mat-icon>
                <mat-label>Challenges Faced </mat-label>
                <mat-select formControlName="challengesFaced" multiple>
                    <mat-option *ngFor="let c of _challengesFaced$|async" [value]="c">{{c}}</mat-option>
<!--                    <mat-option value="No Complains">No Complains</mat-option>-->
<!--                    <mat-option value="Alcohol abuse">Alcohol abuse</mat-option>-->
<!--                    <mat-option value="Drug abuse">Drug abuse</mat-option>-->
<!--                    <mat-option value="Smoking">Smoking</mat-option>-->
<!--                    <mat-option value="Eating Issues"> Eating Issues</mat-option>-->
<!--                    <mat-option value="Hygiene & Sanitation"> Hygiene & Sanitation</mat-option>-->
<!--                    <mat-option value="Anxiety"> Anxiety</mat-option>-->
<!--                    <mat-option value="Depression"> Depression</mat-option>-->
<!--                    <mat-option value="Suicidal Thoughts"> Suicidal Thoughts</mat-option>-->
<!--                    <mat-option value="Adjustment Issues"> Adjustment Issues</mat-option>-->
<!--                    <mat-option value="Behavioral Issues"> Behavioral Issues</mat-option>-->
<!--                    <mat-option value="Self-esteem & Self-confidence"> Self-esteem & Self-confidence</mat-option>-->
<!--                    <mat-option value="Palliative "> Palliative </mat-option>-->
<!--                    <mat-option value="Bereavement">Bereavement</mat-option>-->
<!--                    <mat-option value="Centre Issues"> Centre Issues</mat-option>-->
<!--                    <mat-option value="Sleeping Issues"> Sleeping Issues</mat-option>-->
<!--                    <mat-option value="Anger"> Anger</mat-option>-->
<!--                    <mat-option value="Physical Violence">Physical Violence</mat-option>-->
<!--                    <mat-option value="Abusive language">Abusive language</mat-option>-->

                </mat-select>
                <mat-error *ngIf="form.controls.topicsCovered?.errors?.required">Required</mat-error>

            </mat-form-field>


            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Highlight of session']">info</mat-icon>

                <mat-label>Highlight of session</mat-label>
                <textarea matInput formControlName="highlight" (blur)="onBlur(form.controls.highlight)"></textarea>
                <mat-error *ngIf="form.controls.highlight?.errors?.required">Required</mat-error>
            </mat-form-field>
            <! --------------------------------------------- INTERVENTION --------------------------------------------->

            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['interventions']">info</mat-icon>
                <mat-label>Interventions</mat-label>
                <mat-select formControlName="interventions" multiple>
                <mat-option *ngFor="let skill of (_interventionsList$|async)" [value]="skill">{{skill}}</mat-option>
                </mat-select>
                    <mat-error *ngIf="form.controls.interventions?.errors?.required">Required</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Intervention Used']">info</mat-icon>

                <mat-label>Intervention Used</mat-label>
                <textarea matInput formControlName="interventionUsed" (blur)="onBlur(form.controls.interventionUsed)"></textarea>
                                <mat-error *ngIf="form.controls.interventionUsed?.errors?.required">Required</mat-error>

            </mat-form-field>
            <!*--------------------------------------------- HOME PROGRAM--------------------------------------------->
            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
              <mat-icon *ngIf="mGlossaryData" matSuffix matTooltipPosition="above" [matTooltip]="mGlossaryData['Home Program']">info</mat-icon>


                <mat-label>Home Program</mat-label>
                <textarea matInput formControlName="homeProgram" (blur)="onBlur(form.controls.homeProgram)"></textarea>
<!--                <mat-error *ngIf="form.controls.homeProgram?.errors?.required">Required</mat-error>-->
            </mat-form-field>


            <!--            <mat-form-field appearance="outline">-->
            <!--                <mat-label>Intervention Used</mat-label>-->
            <!--                <textarea matInput formControlName="interventionUsed"></textarea>-->
            <!--                <mat-error *ngIf="form.controls.highlight?.errors?.required">Required</mat-error>-->
            <!--            </mat-form-field>-->



            <div class="d-flex justify-content-center">
                <button mat-raised-button color="warn" (click)="Cancel()">Cancel</button>&nbsp;&nbsp;
                <button mat-raised-button color="primary" type="submit" [disabled]="disableSubmit" (click)="Submit()">Submit</button>
            </div>

        </div>
    </form>
    <!--        <prettyjson [obj]="form.value"></prettyjson>-->

</div>
